// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file penumbra/core/component/fee/v1/fee.proto (package penumbra.core.component.fee.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { Amount } from "../../../num/v1/num_pb.js";
import { AssetId } from "../../../asset/v1/asset_pb.js";
/**
 * Specifies fees paid by a transaction.
 *
 * @generated from message penumbra.core.component.fee.v1.Fee
 */
export class Fee extends Message {
    /**
     * The amount of the token used to pay fees.
     *
     * @generated from field: penumbra.core.num.v1.Amount amount = 1;
     */
    amount;
    /**
     * If present, the asset ID of the token used to pay fees.
     * If absent, specifies the staking token implicitly.
     *
     * @generated from field: penumbra.core.asset.v1.AssetId asset_id = 2;
     */
    assetId;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.fee.v1.Fee";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "amount", kind: "message", T: Amount },
        { no: 2, name: "asset_id", kind: "message", T: AssetId },
    ]);
    static fromBinary(bytes, options) {
        return new Fee().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Fee().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Fee().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Fee, a, b);
    }
}
/**
 * Gas usage for a transaction.
 *
 * Gas used is multiplied by `GasPrices` to determine a `Fee`.
 *
 * @generated from message penumbra.core.component.fee.v1.Gas
 */
export class Gas extends Message {
    /**
     * The amount of block space used.
     *
     * @generated from field: uint64 block_space = 1;
     */
    blockSpace = protoInt64.zero;
    /**
     * The amount of compact block space used.
     *
     * @generated from field: uint64 compact_block_space = 2;
     */
    compactBlockSpace = protoInt64.zero;
    /**
     * The amount of verification cost used.
     *
     * @generated from field: uint64 verification = 3;
     */
    verification = protoInt64.zero;
    /**
     * The amount of execution cost used.
     *
     * @generated from field: uint64 execution = 4;
     */
    execution = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.fee.v1.Gas";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "block_space", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 2, name: "compact_block_space", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 3, name: "verification", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 4, name: "execution", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new Gas().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Gas().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Gas().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Gas, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.fee.v1.GasPrices
 */
export class GasPrices extends Message {
    /**
     * The asset ID of the fee token these prices are for.
     *
     * If absent, specifies the staking token implicitly.
     *
     * @generated from field: penumbra.core.asset.v1.AssetId asset_id = 15;
     */
    assetId;
    /**
     * The price per unit block space in terms of the staking token, with an implicit 1,000 denominator.
     *
     * @generated from field: uint64 block_space_price = 1;
     */
    blockSpacePrice = protoInt64.zero;
    /**
     * The price per unit compact block space in terms of the staking token, with an implicit 1,000 denominator.
     *
     * @generated from field: uint64 compact_block_space_price = 2;
     */
    compactBlockSpacePrice = protoInt64.zero;
    /**
     * The price per unit verification cost in terms of the staking token, with an implicit 1,000 denominator.
     *
     * @generated from field: uint64 verification_price = 3;
     */
    verificationPrice = protoInt64.zero;
    /**
     * The price per unit execution cost in terms of the staking token, with an implicit 1,000 denominator.
     *
     * @generated from field: uint64 execution_price = 4;
     */
    executionPrice = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.fee.v1.GasPrices";
    static fields = proto3.util.newFieldList(() => [
        { no: 15, name: "asset_id", kind: "message", T: AssetId },
        { no: 1, name: "block_space_price", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 2, name: "compact_block_space_price", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 3, name: "verification_price", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 4, name: "execution_price", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new GasPrices().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GasPrices().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GasPrices().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GasPrices, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.fee.v1.FeeTier
 */
export class FeeTier extends Message {
    /**
     * The selected fee tier.
     *
     * @generated from field: penumbra.core.component.fee.v1.FeeTier.Tier fee_tier = 1;
     */
    feeTier = FeeTier_Tier.UNSPECIFIED;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.fee.v1.FeeTier";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "fee_tier", kind: "enum", T: proto3.getEnumType(FeeTier_Tier) },
    ]);
    static fromBinary(bytes, options) {
        return new FeeTier().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FeeTier().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FeeTier().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FeeTier, a, b);
    }
}
/**
 * The tier for the fee.
 *
 * @generated from enum penumbra.core.component.fee.v1.FeeTier.Tier
 */
export var FeeTier_Tier;
(function (FeeTier_Tier) {
    /**
     * @generated from enum value: TIER_UNSPECIFIED = 0;
     */
    FeeTier_Tier[FeeTier_Tier["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: TIER_LOW = 1;
     */
    FeeTier_Tier[FeeTier_Tier["LOW"] = 1] = "LOW";
    /**
     * @generated from enum value: TIER_MEDIUM = 2;
     */
    FeeTier_Tier[FeeTier_Tier["MEDIUM"] = 2] = "MEDIUM";
    /**
     * @generated from enum value: TIER_HIGH = 3;
     */
    FeeTier_Tier[FeeTier_Tier["HIGH"] = 3] = "HIGH";
})(FeeTier_Tier || (FeeTier_Tier = {}));
// Retrieve enum metadata with: proto3.getEnumType(FeeTier_Tier)
proto3.util.setEnumType(FeeTier_Tier, "penumbra.core.component.fee.v1.FeeTier.Tier", [
    { no: 0, name: "TIER_UNSPECIFIED" },
    { no: 1, name: "TIER_LOW" },
    { no: 2, name: "TIER_MEDIUM" },
    { no: 3, name: "TIER_HIGH" },
]);
/**
 * Fee component configuration data.
 *
 * @generated from message penumbra.core.component.fee.v1.FeeParameters
 */
export class FeeParameters extends Message {
    /**
     * Fixed gas prices in the native token used to compute transactions' base
     * fees.
     *
     * In the future, this should be removed and replaced with parameters for
     * dynamic gas pricing.
     *
     * @generated from field: penumbra.core.component.fee.v1.GasPrices fixed_gas_prices = 1;
     */
    fixedGasPrices;
    /**
     * Fixed gas prices in other tokens used to compute transactions' base fees.
     *
     * In the future, this should be removed and replaced with fixed multiples of
     * the native token's price (so that there is one set of dynamically
     * determined gas prices in the native token, and derived gas prices in other
     * alternative tokens).
     *
     * If this is empty, no other tokens are accepted for gas.
     *
     * @generated from field: repeated penumbra.core.component.fee.v1.GasPrices fixed_alt_gas_prices = 2;
     */
    fixedAltGasPrices = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.fee.v1.FeeParameters";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "fixed_gas_prices", kind: "message", T: GasPrices },
        { no: 2, name: "fixed_alt_gas_prices", kind: "message", T: GasPrices, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new FeeParameters().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FeeParameters().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FeeParameters().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FeeParameters, a, b);
    }
}
/**
 * Fee-specific genesis content.
 *
 * @generated from message penumbra.core.component.fee.v1.GenesisContent
 */
export class GenesisContent extends Message {
    /**
     * The FeeParameters present at genesis.
     *
     * @generated from field: penumbra.core.component.fee.v1.FeeParameters fee_params = 1;
     */
    feeParams;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.fee.v1.GenesisContent";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "fee_params", kind: "message", T: FeeParameters },
    ]);
    static fromBinary(bytes, options) {
        return new GenesisContent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenesisContent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenesisContent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenesisContent, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.fee.v1.CurrentGasPricesRequest
 */
export class CurrentGasPricesRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.fee.v1.CurrentGasPricesRequest";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new CurrentGasPricesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CurrentGasPricesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CurrentGasPricesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CurrentGasPricesRequest, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.fee.v1.CurrentGasPricesResponse
 */
export class CurrentGasPricesResponse extends Message {
    /**
     * The current gas prices, in the preferred (native) token.
     *
     * @generated from field: penumbra.core.component.fee.v1.GasPrices gas_prices = 1;
     */
    gasPrices;
    /**
     * Other gas prices for other accepted tokens.
     *
     * @generated from field: repeated penumbra.core.component.fee.v1.GasPrices alt_gas_prices = 2;
     */
    altGasPrices = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.fee.v1.CurrentGasPricesResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "gas_prices", kind: "message", T: GasPrices },
        { no: 2, name: "alt_gas_prices", kind: "message", T: GasPrices, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new CurrentGasPricesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CurrentGasPricesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CurrentGasPricesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CurrentGasPricesResponse, a, b);
    }
}
/**
 * Emitted during fee payment.
 *
 * @generated from message penumbra.core.component.fee.v1.EventPaidFee
 */
export class EventPaidFee extends Message {
    /**
     * The fee paid.
     *
     * @generated from field: penumbra.core.component.fee.v1.Fee fee = 1;
     */
    fee;
    /**
     * The base fee that was required.
     *
     * @generated from field: penumbra.core.component.fee.v1.Fee base_fee = 2;
     */
    baseFee;
    /**
     * The tip that was paid to the proposer.
     *
     * @generated from field: penumbra.core.component.fee.v1.Fee tip = 3;
     */
    tip;
    /**
     * The gas used to compute the base fee.
     *
     * @generated from field: penumbra.core.component.fee.v1.Gas gas_used = 4;
     */
    gasUsed;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.fee.v1.EventPaidFee";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "fee", kind: "message", T: Fee },
        { no: 2, name: "base_fee", kind: "message", T: Fee },
        { no: 3, name: "tip", kind: "message", T: Fee },
        { no: 4, name: "gas_used", kind: "message", T: Gas },
    ]);
    static fromBinary(bytes, options) {
        return new EventPaidFee().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EventPaidFee().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EventPaidFee().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EventPaidFee, a, b);
    }
}
/**
 * Emitted as a summary of fees in the block.
 *
 * @generated from message penumbra.core.component.fee.v1.EventBlockFees
 */
export class EventBlockFees extends Message {
    /**
     * The total fees, after swapping to the native token.
     *
     * @generated from field: penumbra.core.component.fee.v1.Fee swapped_fee_total = 1;
     */
    swappedFeeTotal;
    /**
     * The total base fees, after swapping to the native token.
     *
     * @generated from field: penumbra.core.component.fee.v1.Fee swapped_base_fee_total = 2;
     */
    swappedBaseFeeTotal;
    /**
     * The total tips, after swapping to the native token.
     *
     * @generated from field: penumbra.core.component.fee.v1.Fee swapped_tip_total = 3;
     */
    swappedTipTotal;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.fee.v1.EventBlockFees";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "swapped_fee_total", kind: "message", T: Fee },
        { no: 2, name: "swapped_base_fee_total", kind: "message", T: Fee },
        { no: 3, name: "swapped_tip_total", kind: "message", T: Fee },
    ]);
    static fromBinary(bytes, options) {
        return new EventBlockFees().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EventBlockFees().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EventBlockFees().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EventBlockFees, a, b);
    }
}
